import React, { useState } from 'react';
import { 
  FaBalanceScale, 
  FaShieldAlt, 
  FaCheckCircle,
  FaServer,
  FaBuilding,
  FaLock,
  FaDatabase,
  FaCookie,
  FaUserLock,
  FaCopyright,
  FaGlobe,
  FaExclamationTriangle,
  FaClock,
  FaFileAlt
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';

const MentionsLegales = () => {
  const [activeSection, setActiveSection] = useState(null);

  const sections = [
    {
      id: 1,
      icon: FaBuilding,
      title: "1. Informations légales",
      content: `**RAISON SOCIALE**

CINEF S.A.S
Siège social : Ilot 1398 Sainte Rita, Immeuble Marcellin BOCOVE
03 BP 3620 Cotonou, République du Bénin

**CONTACT**
Courriel : info@cinef-bj.com
Téléphone : +229 63 18 60 60

**IDENTIFICATION**
IFU : 3 201 710 132 671
N° RC : RCCM RB/COT/17-B-20126
N° CNSS : 17640657
Président : Wilfrid DEDJI`
    },
    {
      id: 2,
      icon: FaServer,
      title: "2. Hébergement",
      content: `Le site www.cinef-bj.com est hébergé par :

**DYDITECH**
14455 North Hayden Rd
Suite 219
Scottsdale, AZ, 85260
États-Unis d'Amérique`
    },
    {
      id: 3,
      icon: FaUserLock,
      title: "3. Protection des données personnelles",
      content: `Conformément aux lois n° 2017-20 portant code du numérique en République du Bénin et n°2009-09 du 22 mai 2009 portant protection des données à caractère personnel en République du Bénin, le site www.cinef-bj.com a fait l'objet d'une déclaration auprès de l'Autorité de Protection des Données à caractère Personnel.

**VOS DROITS**
Vous disposez d'un droit d'accès, de rectification et d'opposition aux données personnelles vous concernant. Pour exercer ces droits, il suffit de nous en faire la demande par mail via notre formulaire de contact ou à l'adresse info@cinef-bj.com.`
    },
    {
      id: 4,
      icon: FaDatabase,
      title: "4. Données collectées",
      content: `**CLIENTS PROFESSIONNELS**
Pour nos clients entreprises, nous collectons :
• Nom et prénom des interlocuteurs
• Adresse email professionnelle
• Fonction dans l'entreprise
• Adresse postale
• Numéro de téléphone
• Informations communiquées volontairement si pertinentes

**STAGIAIRES**
Pour les participants aux formations, nous collectons :
• Nom et prénom
• Employeur
• Profession
• Adresse email et postale
• Numéro de téléphone
• Informations sur d'éventuelles allergies alimentaires (uniquement pour l'organisation des repas)
• Informations sur d'éventuelles situations de handicap (pour adapter les conditions de formation)`
    },
    {
      id: 5,
      icon: FaFileAlt,
      title: "5. Finalités du traitement",
      content: `**POUR LES CLIENTS**
Les données sont utilisées pour :
• L'exécution des actions de formation professionnelle
• La réalisation d'études marketing et statistiques internes
• Des actions de prospection commerciale (si vous n'avez pas opposé votre refus)

**POUR LES STAGIAIRES**
Les données servent à :
• L'enregistrement des inscriptions
• L'envoi des confirmations et documents légaux
• L'élaboration des listes d'émargement
• La délivrance des attestations de présence et de formation
• L'accès aux plateformes de formation en ligne (CINEF ELEARNING)
• L'envoi d'offres et d'informations (avec possibilité de désabonnement)`
    },
    {
      id: 6,
      icon: FaLock,
      title: "6. Destinataires des données",
      content: `Vos données personnelles peuvent être transmises à :

• **Les services internes de CINEF** en charge de la gestion de la formation
• **Les sous-traitants et partenaires** uniquement pour l'exécution des prestations de formation
• **Les organismes publics** pour répondre à nos obligations légales (contrôle et financement de la formation professionnelle)
• **Les auxiliaires de justice** et organismes de recouvrement si nécessaire`
    },
    {
      id: 7,
      icon: FaClock,
      title: "7. Durée de conservation",
      content: `**DONNÉES DE FORMATION**
Les données collectées pour l'exécution d'une prestation de formation sont conservées pendant la durée strictement nécessaire à la gestion, puis archivées jusqu'à l'expiration de la durée de prescription légale applicable.

**DONNÉES COMMERCIALES**
Les données collectées à des fins de prospection commerciale sont conservées pendant une durée maximale de cinq (5) ans à compter de la fin de la relation commerciale.

**DONNÉES SENSIBLES**
Les données concernant d'éventuelles allergies alimentaires ou situations de handicap sont conservées uniquement pour la durée de l'action de formation.`
    },
    {
      id: 8,
      icon: FaShieldAlt,
      title: "8. Mesures de sécurité",
      content: `CINEF met en œuvre des mesures techniques et organisationnelles pour protéger vos données :

• Sécurisation de l'accès à nos locaux et plates-formes informatiques
• Sécurisation de l'accès, du partage et du transfert de données
• Sensibilisation de nos collaborateurs aux exigences de confidentialité
• Nomination d'un responsable à la protection des données`
    },
    {
      id: 9,
      icon: FaCookie,
      title: "9. Cookies",
      content: `Les cookies utilisés par www.cinef-bj.com permettent de personnaliser le contenu du site et d'optimiser votre expérience utilisateur.

**TYPES DE COOKIES**

• **Cookies techniques** : Nécessaires au fonctionnement du site (navigation, connexion, historique)
• **Cookies de mesure d'audience** : Statistiques de fréquentation et amélioration du site
• **Cookies publicitaires** : Affichage de publicités pertinentes

**GESTION DES COOKIES**
Vous pouvez paramétrer votre navigateur pour accepter ou refuser les cookies. Pour bénéficier de toutes les fonctionnalités du site, il est préférable d'accepter tous les cookies.`
    },
    {
      id: 10,
      icon: FaCopyright,
      title: "10. Propriété intellectuelle",
      content: `Le site internet www.cinef-bj.com est la propriété de la société CINEF SAS.

Les marques CINEF et tous les éléments (textes, commentaires, ouvrages, illustrations, logos, marques, vidéos et images) affichés sur le site sont protégés par le droit de la propriété intellectuelle.

Conformément au Code de la Propriété Intellectuelle, toute utilisation ou reproduction totale ou partielle sans autorisation expresse et écrite de CINEF SAS est interdite.`
    },
    {
      id: 11,
      icon: FaGlobe,
      title: "11. Utilisation du site",
      content: `CINEF s'engage à mettre en œuvre tous les moyens à sa disposition pour assurer la fiabilité de l'utilisation du site internet et de ses contenus.

**LIMITATION DE RESPONSABILITÉ**
CINEF ne saurait être tenu responsable en cas de :
• Erreurs ou interruptions
• Dysfonctionnements ou perte de données
• Saturation du réseau internet
• Défaillance du matériel de réception ou des lignes de communication
• Nature ou contenu des sites tiers référencés`
    },
    {
      id: 12,
      icon: FaBalanceScale,
      title: "12. Confidentialité",
      content: `CINEF et son site www.cinef-bj.com s'engagent à ne pas divulguer à des tiers les informations que vous nous communiquez. Celles-ci sont confidentielles.

Toute information concernant notre société se trouvant sur Internet en dehors de notre site officiel, transmise sans notre autorisation, ne saurait engager notre responsabilité.

Les informations collectées ne seront utilisées par nos services internes que pour le traitement de votre demande.`
    }
  ];

  const highlightBold = (text) => {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      return part;
    });
  };

  return (
    <>
      <Header />
      <div className="mentions-wrapper">
        {/* Hero Section */}
        <section className="mentions-hero">
          <div className="container">
            <div className="hero-content">
              <div className="hero-badge">
                <FaBalanceScale className="badge-icon" />
                <span>Document Officiel</span>
              </div>
              <h1 className="hero-title">
                Mentions 
                <span className="gradient-text">Légales</span>
              </h1>
              <p className="hero-description">
                Informations légales, politique de confidentialité et conditions d'utilisation 
                du site www.cinef-bj.com conformément à la réglementation béninoise en vigueur.
              </p>
              <div className="hero-info">
                <div className="info-item">
                  <FaCheckCircle />
                  <span>Conforme aux lois béninoises</span>
                </div>
                <div className="info-item">
                  <FaShieldAlt />
                  <span>Données protégées</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="intro-section">
          <div className="container">
            <div className="intro-card">
              <div className="intro-icon">
                <FaExclamationTriangle />
              </div>
              <div className="intro-content">
                <h3>Politique de confidentialité et protection des données</h3>
                <p>
                  Ce document présente la politique en vigueur sur le site www.cinef-bj.com 
                  édité par la société CINEF SAS, en matière de vie privée et de protection 
                  des données à caractère personnel conformément aux lois n° 2017-20 portant 
                  code du numérique et n°2009-09 du 22 mai 2009 portant protection des données 
                  à caractère personnel en République du Bénin.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Mentions Sections */}
        <section className="mentions-content">
          <div className="container">
            <div className="sections-grid">
              {sections.map((section) => {
                const Icon = section.icon;
                const isActive = activeSection === section.id;
                
                return (
                  <div 
                    key={section.id} 
                    className={`section-card ${isActive ? 'active' : ''}`}
                    onClick={() => setActiveSection(isActive ? null : section.id)}
                  >
                    <div className="section-header">
                      <div className="section-icon">
                        <Icon />
                      </div>
                      <h3>{section.title}</h3>
                    </div>
                    
                    {isActive && (
                      <div className="section-content">
                        {section.content.split('\n\n').map((paragraph, idx) => (
                          <p key={idx}>{highlightBold(paragraph)}</p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>
       

        <style>{`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          .mentions-wrapper {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
            color: #1a202c;
            background: #ffffff;
          }

          .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
          }

          /* Hero Section */
          .mentions-hero {
            background: linear-gradient(135deg, #f0f4f8 0%, #ffffff 100%);
            padding: 100px 0 80px;
            position: relative;
            overflow: hidden;
          }

          .mentions-hero::before {
            content: '';
            position: absolute;
            top: -20%;
            right: -10%;
            width: 500px;
            height: 500px;
            background: radial-gradient(circle, rgba(25, 135, 84, 0.08) 0%, transparent 70%);
            border-radius: 50%;
          }

          .hero-content {
            text-align: center;
            position: relative;
            z-index: 1;
          }

          .hero-badge {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: white;
            padding: 10px 24px;
            border-radius: 50px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            margin-bottom: 24px;
            font-size: 14px;
            font-weight: 600;
            color: #198754;
          }

          .badge-icon {
            animation: swing 2s ease-in-out infinite;
          }

          @keyframes swing {
            0%, 100% { transform: rotate(-5deg); }
            50% { transform: rotate(5deg); }
          }

          .hero-title {
            font-size: 56px;
            font-weight: 900;
            line-height: 1.15;
            color: #1a202c;
            margin-bottom: 20px;
            letter-spacing: -1.5px;
          }

          .gradient-text {
            background: linear-gradient(135deg, #198754 0%, #dc3545 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-left: 8px;
          }

          .hero-description {
            font-size: 18px;
            line-height: 1.7;
            color: #4a5568;
            max-width: 750px;
            margin: 0 auto 32px;
          }

          .hero-info {
            display: flex;
            gap: 32px;
            justify-content: center;
            flex-wrap: wrap;
          }

          .info-item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 15px;
            color: #718096;
            font-weight: 500;
          }

          .info-item svg {
            color: #198754;
            font-size: 18px;
          }

          /* Introduction Section */
          .intro-section {
            padding: 60px 0;
            background: white;
          }

          .intro-card {
            display: flex;
            gap: 24px;
            padding: 32px;
            background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
            border-radius: 16px;
            border-left: 4px solid #198754;
          }

          .intro-icon {
            width: 48px;
            height: 48px;
            background: white;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #198754;
            font-size: 24px;
            flex-shrink: 0;
          }

          .intro-content h3 {
            font-size: 20px;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 12px;
          }

          .intro-content p {
            font-size: 15px;
            line-height: 1.7;
            color: #4a5568;
          }

          /* Mentions Content Section */
          .mentions-content {
            padding: 80px 0;
            background: #fafafa;
          }

          .sections-grid {
            display: grid;
            gap: 20px;
          }

          .section-card {
            background: white;
            border-radius: 16px;
            border: 2px solid #e2e8f0;
            overflow: hidden;
            transition: all 0.3s ease;
            cursor: pointer;
          }

          .section-card:hover {
            border-color: #198754;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
          }

          .section-card.active {
            border-color: #198754;
            box-shadow: 0 12px 32px rgba(25, 135, 84, 0.15);
          }

          .section-header {
            display: flex;
            align-items: center;
            gap: 20px;
            padding: 28px 32px;
          }

          .section-icon {
            width: 56px;
            height: 56px;
            background: linear-gradient(135deg, #fd7e14 0%, #dc3545 50%);
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 24px;
            flex-shrink: 0;
            transition: all 0.3s ease;
          }

          .section-card:hover .section-icon {
            transform: scale(1.05) rotate(5deg);
          }

          .section-header h3 {
            font-size: 18px;
            font-weight: 700;
            color: #1a202c;
            flex: 1;
          }

          .section-content {
            padding: 0 32px 28px 108px;
            animation: slideDown 0.3s ease;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .section-content p {
            font-size: 15px;
            line-height: 1.8;
            color: #4a5568;
            margin-bottom: 16px;
            white-space: pre-line;
          }

          .section-content p:last-child {
            margin-bottom: 0;
          }

          .section-content strong {
            color: #1a202c;
            font-weight: 700;
            display: block;
            margin-top: 12px;
            margin-bottom: 8px;
          }

          /* Contact Section */
          .contact-section {
            padding: 80px 0;
            background: linear-gradient(135deg, #fd7e14 0%, #dc3545 50%, #198754 100%);
            position: relative;
            overflow: hidden;
          }

          .contact-section::before {
            content: '';
            position: absolute;
            top: -30%;
            right: -15%;
            width: 600px;
            height: 600px;
            background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
            border-radius: 50%;
          }

          .contact-card {
            position: relative;
            z-index: 1;
          }

          .contact-content {
            text-align: center;
            color: white;
          }

          .contact-icon {
            width: 80px;
            height: 80px;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            margin: 0 auto 24px;
          }

          .contact-content h2 {
            font-size: 36px;
            font-weight: 900;
            margin-bottom: 16px;
          }

          .contact-content p {
            font-size: 18px;
            line-height: 1.7;
            opacity: 0.95;
            max-width: 650px;
            margin: 0 auto 32px;
          }

          .contact-btn {
            display: inline-flex;
            align-items: center;
            gap: 12px;
            padding: 18px 40px;
            background: white;
            color: #198754;
            border-radius: 12px;
            font-size: 17px;
            font-weight: 700;
            text-decoration: none;
            transition: all 0.3s ease;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          }

          .contact-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
          }

          
          
          .legal-text {
            font-size: 13px;
            line-height: 1.8;
            color: #cbd5e0;
            text-align: center;
          }

          .legal-text strong {
            color: #ffffff;
            font-weight: 600;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .hero-title {
              font-size: 40px;
            }

            .hero-description {
              font-size: 16px;
            }

            .hero-info {
              flex-direction: column;
              gap: 16px;
            }

            .intro-card {
              flex-direction: column;
              padding: 24px;
            }

            .section-content {
              padding: 0 24px 24px 24px;
            }

            .section-header {
              padding: 20px 24px;
            }

            .contact-content h2 {
              font-size: 28px;
            }

            .contact-content p {
              font-size: 16px;
            }

            .contact-btn {
              width: 100%;
              justify-content: center;
            }

            .legal-text {
              font-size: 12px;
              text-align: left;
            }
          }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

export default MentionsLegales;